import type { ComposerTranslation } from 'vue-i18n'

/**
 * 域名访问限制策略：`limit_type` 与策略 JSON 中 URL 列表字段名的对应（black_list / white_list / record_only）。
 * 列表页 `access-restriction.vue`、表单 `strategy-setting.vue`、命中日志列表（`formatNetLimitLogLimitType`）共用。
 *
 * 短文案统一走 i18n：`accessRestriction.blacklist` / `whitelist` / `recordOnly`（勿再维护 `domainInterceptEvent.limitTypeValues`）。
 */
export const ACCESS_RESTRICTION_LIMIT_TYPE_KEY = {
  1: 'black_list',
  2: 'white_list',
  3: 'record_only',
} as const

export type AccessRestrictionLimitTypeKey =
  (typeof ACCESS_RESTRICTION_LIMIT_TYPE_KEY)[keyof typeof ACCESS_RESTRICTION_LIMIT_TYPE_KEY]

/** 列表/表格中展示「策略属性」短标签（黑名单 / 白名单 / 仅记录） */
export function translateAccessRestrictionLimitType (
  t: ComposerTranslation,
  limitType: number | string | undefined | null,
): string {
  const s = String(limitType ?? '')
  if (s === '1') return t('accessRestriction.blacklist')
  if (s === '2') return t('accessRestriction.whitelist')
  if (s === '3') return t('accessRestriction.recordOnly')
  return '--'
}
